export default "__VITE_ASSET__j6_y9bgP__"